import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

import Home from "../components/Home.vue";
import Downloads from "../components/Downloads.vue";
import Signin from "../components/Signin.vue";
import Signup from "../components/admin/Admin_Signup.vue";
import UploadFile from "../components/admin/Admin_UploadFile.vue";
import Targeted from "../components/admin/Admin_Targeted.vue";
import Exercises from "../components/Targeted.vue";
import ExcerciseList from "../components/exercises.vue";
import Admin from "../components/admin/Admin.vue";
import AddGreeting from "../components/admin/Admin_AddGreeting.vue";
import AddSong from "../components/admin/Admin_AddSong.vue";
import NewSonglist from "../components/admin/Admin_New_Songlist.vue";
import Songlists from "../components/Songlists.vue";
import EditSong from "../components/admin/Admin_Edit_Song.vue";
import EditGreeting from "../components/admin/Admin_EditGreeting.vue";
import EditSonglist from "../components/admin/Admin_Edit_Songlist.vue";
import EditItem from "../components/admin/Admin_EditItem.vue";
import ViewItems from "../components/admin/Admin_ViewItems.vue";
import ViewStudents from "../components/admin/Admin_ViewStudents.vue";
import EditStudent from "../components/admin/Admin_Edit_Student.vue";
import ViewLessons from "../components/admin/Admin_View_Lessons.vue";
import SetUnavailable from "../components/admin/Admin_SetUnavailableDates.vue";
import LessonSignUp from "../components/LessonSignUp.vue";
import LessonsDisplay from "../components/LessonsDisplay.vue";

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes: [
    { path: "/", component: Home },
    { path: "/downloads", component: Downloads, meta: { requiresAuth: true } },
    { path: "/editItem", name: "editItem", component: EditItem, props: true, meta: { requiresAuth: true }},
    { path: "/viewItems", component: ViewItems, meta: { requiresAuth: true } },
    { path: "/viewStudents", component: ViewStudents, meta: { requiresAuth: true }},
    { path: "/editStudent", name: "editStudent", component: EditStudent, props: true, meta: { requiresAuth: true }},
    { path: "/editGreeting", name: "editGreeting", component: EditGreeting, props: true, meta: { requiresAuth: true }},
    { path: "/editSonglist", name: "editSonglist", component: EditSonglist, props: true, meta: { requiresAuth: true }},
    { path: "/signin", name: "signin", component: Signin },
    { path: "/signup", name: "signup", component: Signup },
    { path: "/upload", component: UploadFile, meta: { requiresAuth: true }},
    { path: "/targeted", component: Targeted, meta: { requiresAuth: true }},
    { path: "/exercises", component: Exercises, meta: { requiresAuth: true }},
    { path: "/exerciseList", component: ExcerciseList, meta: { requiresAuth: true }},
    { path: "/admin", component: Admin, meta: { requiresAuth: true } },
    { path: "/viewLessons", component: ViewLessons, meta: { requiresAuth: true }},
    { path: "/greeting", component: AddGreeting, meta: { requiresAuth: true }},
    { path: "/addSong", component: AddSong, meta: { requiresAuth: true } },
    { path: "/songlists", component: Songlists, meta: { requiresAuth: true }},
    { path: "/newSonglist", component: NewSonglist, meta: { requiresAuth: true }},
    { path: "/editSong", component: EditSong, name: "editSong", props: true },
    { path: "/lessons", component: LessonSignUp, meta: { requiresAuth: true } },
    { path: "/lessonsDisplay", component: LessonsDisplay,meta: { requiresAuth: true }},
    { path: "/disallowedDates", component: SetUnavailable, meta: { requiresAuth: true }},
    { path: "*", redirect: "/" }
  ]
});
